export default __webpack_public_path__ + "static/media/arrow-down.5bff5d9d.svg";